import React from 'react';
export function LightsOutSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-2999">
      <h2 className="text-2xl md:text-3xl font-bold text-[#1967a5] mb-6 border-b border-gray-200 pb-4" data-id="element-3000">
        Working on the Weekend - Lights out Machining for EDM
      </h2>
      <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-3001">
        <div className="space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-3002">
          <p data-id="element-3003">
            Weekends are for the family. Weekends account for 104 out of 365
            days - which equals 2,496 hours or 28.5 percent of one year's time.
            People working on the weekends is a thing of the past. Your WEDM
            must have one or more of the following in order to compete in
            today's global economy:
          </p>
          <ul className="list-disc list-inside space-y-2 text-base" data-id="element-3004">
            <li data-id="element-3005">
              Automatic wire threader (AWT) device to move from one pocket to
              another unattended.
            </li>
            <li data-id="element-3006">
              Automatic re-threading device (RTH) in case the wire breaks
              accidentally.
            </li>
            <li data-id="element-3007">
              Automatic restart device (ART) in case the main power to the
              machine goes down momentarily.
            </li>
            <li data-id="element-3008">
              Large 20/25 kg (44/55 lb.) wire spool option to handle the weekend
              operation.
            </li>
            <li data-id="element-3009">
              Automatic pallet changer or robot to load/unload workpieces at
              night or over the weekend.
            </li>
          </ul>
          <p className="font-bold text-navy" data-id="element-3010">
            Call your OEM and find out about what programs they offer for
            upgrading your existing wire EDM.
          </p>
          <p data-id="element-3011">
            The EDM foreman at one European company that does work for Rolex had
            trouble justifying the purchase of a robot to upper management for
            many years. Management firmly believed that the WEDM was not a place
            where the cost of a robot could be justified. Eventually, management
            agreed to retrofit a robot on one of their existing machines on a
            trial basis. During the day, the operators continued to run the
            machine in manual mode. At 5:00 p.m., the WEDM was switched to
            automatic mode and the robot would finish various parts that were
            left waiting in the robot carousel. Management saw the WEDM
            productivity jump from 40 hours to 100 hours per week. This customer
            now states that they would never buy another WEDM without a robot.
          </p>
        </div>
        <div data-id="element-3012">
          <a href="59m7/agiecharmilles-edm/wire-edm/high-speed.html" className="block hover:opacity-90 transition-opacity" data-id="element-3013">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Reedesign%2007.11/Limitless%20Possibilities.jpg" alt="Limitless Possibilities" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-3014" />
          </a>
        </div>
      </div>
    </div>;
}